/**
 * The language of the exam content shown by the shared course components (D-107): English for
 * the IELTS (the default, unchanged), French for the TCF. It sets the `lang` of the texts, the
 * labels of true / false / not given and the voice that reads the scripts and the vocabulary.
 */

import { type ContentLanguage, contentVoice } from "@agencyos/core";
import { type ReactNode, createContext, useContext } from "react";

import { speakEnglish } from "./speech";
import { speakIn } from "./voice";

const ContentLang = createContext<ContentLanguage>("en");

export function ContentLangProvider({ lang, children }: { lang: ContentLanguage; children: ReactNode }) {
  return <ContentLang.Provider value={lang}>{children}</ContentLang.Provider>;
}

export function useContentLang(): ContentLanguage {
  return useContext(ContentLang);
}

/** Reads a text of the content in its language: en-GB for the IELTS, fr-FR for the TCF. */
export function useSpeakContent(): (text: string) => Promise<void> {
  const lang = useContext(ContentLang);
  // German (D-118): de-DE
  return (text: string) => (lang === "en" ? speakEnglish(text) : speakIn(text, contentVoice(lang === "de" ? "goethe" : "tcf_canada")));
}
